// @flow
import { connect } from 'react-redux';

import Download from 'components/fragments/Download';
import type { StateProps } from 'components/fragments/Download';
import type { StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  club: state.settingsState.structure
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Download);